import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE_ADD_ITM,
    COMN_URLS_ADD_ITM,
    APIS_ADD_ITM,
    SF_APP_DTL_ADD_ITM,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppAddItmService";

export const APP_AMD_DTL_ADD_ITM = (props: any) => {
    // console.log("APP_AMD_DTL_ADD_ITM props ", props);

    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /** #add-item# additional item */
    const refAddItmList = useRef<any[]>([]); /** addtional item info list */
    const [stateAddItmSchemas, setStateAddItmSchemas] = useState<any[] | undefined>([]);
    const refTemp = useRef<any[]>([]);

    useResource({
        defaultSchema: [], //{ area: "comnCd", comnCd: "" }
    });

    const form = props.form;
    const bfForm = {
        addItmForm: {
            appDtlAddItm: useForm({
                defaultSchema: SF_APP_DTL_ADD_ITM,
            }),
        },
    };

    const appCdNo = props.param.appCdNo;
    const appId = props.param.appId;
    const appClsfCd = props.param.appClsfCd;
    const areaCd = props.area;
    const itemNo = props.itemNo;

    const appDgr = props.param.appDgr;
    const appStatCd = props.param.appStatCd;

    const paramData = {
        additmCpntCd: areaCd,
        appCdNo: appCdNo,
        itmNo: itemNo,
        appDgr: appDgr,
        appStatCd: appStatCd,
    };

    const fetch = {
        /** #add-item# additional item */
        getAdtnlItmByAppCdNoList: useFetch({
            api: (appCdNo, data) => {
                return APIS_ADD_ITM.getAdtnlItmByAppCdNoList(appCdNo, data);
            },
            onSuccess: (data) => {
                console.log("getAdtnlItmByAppCdNoList ==================== ", data.adtnlItmList?.content);
                refAddItmList.current = data.adtnlItmList?.content || [];
                form.appDtlAddItm.setValue("orginAdtnlItmList", refAddItmList.current);

                const bfAdtnlItmList = bfForm.addItmForm.appDtlAddItm.getValues().orginAdtnlItmList;

                setStateAddItmSchemas(
                    APIS_ADD_ITM.getAmdAdtnlItmSchemas(
                        form.appDtlAddItm,
                        data.adtnlItmList?.content || [],
                        false,
                        bfAdtnlItmList,
                    ),
                );
            },
            onError: () => {},
            showToast: false,
        }),
        getBeforeAdtnlItmByAppCdNoList: useFetch({
            api: (appCdNo, data) => {
                return APIS_ADD_ITM.getAdtnlItmByAppCdNoList(appCdNo, data);
            },
            onSuccess: (data) => {
                console.log("getAdtnlItmByAppCdNoList ==================== ", data.adtnlItmList?.content);
                refAddItmList.current = data.adtnlItmList?.content || [];
                bfForm.addItmForm.appDtlAddItm.setValue("orginAdtnlItmList", [...refAddItmList.current]);

                fetch.getAdtnlItmByAppCdNoList.fetch(appId, paramData);
            },
            onError: () => {},
            showToast: false,
        }),
        /** #add-item# additional item */
        getAdtnlItmValueList: useFetch({
            api: (appId, data) => {
                return APIS_ADD_ITM.getAdtnlItmValueList(appId, data);
            },
            onSuccess: (data) => {
                console.log("getAdtnlItmValueList ==================== ", data);
                refAddItmList.current = data.adtnlItmList?.content || [];
                form.appDtlAddItm.setValue("orginAdtnlItmList", refAddItmList.current);

                const bfAdtnlItmList = bfForm.addItmForm.appDtlAddItm.getValues().orginAdtnlItmList;

                setStateAddItmSchemas(
                    APIS_ADD_ITM.getAmdAdtnlItmSchemas(
                        form.appDtlAddItm,
                        data.adtnlItmList?.content || [],
                        false,
                        bfAdtnlItmList,
                    ),
                );
            },
            onError: () => {},
            showToast: false,
        }),
        getBeforeAdtnlItmValueList: useFetch({
            api: (appId, data) => {
                return APIS_ADD_ITM.getAdtnlItmValueList(appId, data);
            },
            onSuccess: (data) => {
                console.log("getAdtnlItmValueList ==================== ", data);
                refAddItmList.current = data.adtnlItmList?.content || [];
                bfForm.addItmForm.appDtlAddItm.setValue("orginAdtnlItmList", [...refAddItmList.current]);

                fetch.getAdtnlItmValueList.fetch(appId, paramData);
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {};

    useEffect(() => {
        if (!props.param?.appId) return;
        const bf = props.bfParam;
        if (!bf?.appId && !bf?.appCdNo) return;
        const bfAppCdNo = bf.appCdNo;
        const bfAppUuid = bf.appId;
        const bfAppDgr = bf.appDgr;
        const bfAppStatCd = bf.appStatCd;
        const bfParamData = {
            additmCpntCd: areaCd,
            appCdNo: bfAppCdNo,
            itmNo: itemNo,
            appDgr: bfAppDgr,
            appStatCd: bfAppStatCd,
        };
        if (bfAppUuid) {
            fetch.getBeforeAdtnlItmValueList.fetch(bfAppUuid, bfParamData);
        } else if (bfAppCdNo) {
            fetch.getBeforeAdtnlItmByAppCdNoList.fetch(bfAppCdNo, bfParamData);
        }
    }, [appId, props.bfParam?.appId, props.bfParam?.appCdNo, areaCd, itemNo]);

    return (
        <>
            {stateAddItmSchemas && stateAddItmSchemas.length > 0 && (
                <Layout direction="col">
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_ADTNL_INFO"} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        {stateAddItmSchemas.map((elem, idx) => {
                            let rightButton = null;
                            if (refAddItmList.current[idx].inpTpCd == "CP") {
                                rightButton = APIS_ADD_ITM.getFormRightButtonCP(
                                    elem.inputName,
                                    elem.comnCd,
                                    form.appDtlAddItm,
                                    modal,
                                );
                            } else if (refAddItmList.current[idx].inpTpCd == "SP") {
                                rightButton = APIS_ADD_ITM.getFormRightButtonPP(
                                    elem.inputName,
                                    refAddItmList.current[idx].adtnlItmCdNo,
                                    form.appDtlAddItm,
                                    modal,
                                );
                            }

                            if (refAddItmList.current[idx].inpTpCd != "CP") {
                                refTemp.current.push(
                                    <Group.Control
                                        key={elem.inputName}
                                        {...form.appDtlAddItm.schema[elem.inputName]}
                                        rightButton={rightButton}
                                    />,
                                );
                            } else {
                                refTemp.current.push(
                                    APIS_ADD_ITM.getFormComponentComnCd(
                                        elem,
                                        form.appDtlAddItm,
                                        elem.inputName,
                                        rightButton,
                                    ),
                                );
                            }

                            if (idx % 2 == 1 || idx == stateAddItmSchemas.length - 1) {
                                let temp = [...refTemp.current];
                                refTemp.current = [];
                                return <Group.Row key={`row-${idx}`}>{temp}</Group.Row>;
                            }
                            return null;
                        })}
                    </Group.Section>
                </Layout>
            )}
        </>
    );
};
